// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "9604bb68ea1425324ee79ef1309ee1486a0ff568/static/css/" + chunkId + "." + "8ea9c403" + ".chunk.css";
};